import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, ViewChild } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbPresenterTemplateConfigComponent } from '../gb-presenter-template-config/gb-presenter-template-config.component'
import { ProjectorTemplatesFacade } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.facade'
import * as ProjectorTemplatesActions from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.actions'
import { ClientAccountEntity } from 'libs/gb-dashboard/client-account/data-access/src/lib/+state/client-account.models'

@Component({
  selector: 'gb-presenter-dialog-template-config',
  imports: [
    CommonModule,
    MatDialogModule,
    TranslateModule,
    GbPresenterTemplateConfigComponent,
    GbDashboardSharedUiModule,
    MatButtonModule,
  ],
  templateUrl: './gb-presenter-dialog-template-config.component.html',
  styleUrl: './gb-presenter-dialog-template-config.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterDialogTemplateConfigComponent implements OnDestroy {
  @ViewChild(GbPresenterTemplateConfigComponent) gbPresenterTemplateConfigComponent?: GbPresenterTemplateConfigComponent

  isSaveProjectorAsTemplateMode = this.data?.templateAsProjector

  selectedTemplate$ = this.projectorTemplatesFacade.selectedProjectorTemplate$

  get template() {
    return this.gbPresenterTemplateConfigComponent?.form.value
  }

  constructor(
    private projectorTemplatesFacade: ProjectorTemplatesFacade,
    @Inject(MAT_DIALOG_DATA) private data: { templateAsProjector: boolean } | null,
  ) {}

  ngOnDestroy(): void {
    this.projectorTemplatesFacade.dispatch(ProjectorTemplatesActions.clearSelectedProjectorTemplate())
  }

  save(): void {
    const { clientAccounts, ...rest } = this.template || {}

    const payload = {
      ...rest,
      client_accounts: this.getClientAccounts(this.template),
    }

    this.projectorTemplatesFacade.dispatch(
      ProjectorTemplatesActions.updateProjectorTemplate({
        template: payload,
        updateConfig: false,
      }),
    )
  }

  getClientAccounts(
    template:
      | Partial<{
          name: string
          description: string
          visibility: 'public' | 'client_account'
          clientAccounts: Partial<ClientAccountEntity>[] | null
        }>
      | undefined,
  ): [] | Partial<ClientAccountEntity>[] {
    if (template?.visibility === 'public' || !template?.clientAccounts) {
      return []
    } else {
      return template.clientAccounts
    }
  }
}
